<template>
<m-pageframe
    title="Intuit Integration Settings"
>
<v-container>

   <h2>Important!</h2>
   <p>Every setting on this page affects the current instance.  For example, if you add a token here in, say, STAGING, then the staging DB now has a token and will refresh it every 10 minutes.</p>
   <p>This can be hard to keep straight as, <b>everywhere other than this page</b>, only PRODUCTION has any tokens and STAGING, BUILD and DEV connect to production to get an access token</p>
   <p>Don't use this page unless you know what you are doing</p>

    <h2>How to get a new Refresh Token</h2>
    <p>
    <ol>
        <li><a href="https://developer.intuit.com/app/developer/playground" target="_blank">Go to the intuit OAuth Playground</a></li>
        <li>Select your app (sandbox or production)</li>
        <li>Select ALL of the scopes</li>
        <li>Click Get Authorization Code</li>
        <li>Scroll Down to Step 2 (Get OAuth 2.0 token from auth code) and click Get tokens</li>
        <li>Scroll Down to Step 4 and copy the refresh token</li>
    </ol>
    </p>

   <h2>Settings</h2>

   <v-select
        :items="realm_choices"
        label="Environment"
        v-model="realm_id"
        v-on:input="update"
   />

   <m-edit-text
        :value="refresh_token"
        label="Refresh Token"
        v-if="realm_id != null"
        v-on:input="onSetRefreshToken"
   />

   <div v-if="token != null">
   <h2>Current Token</h2>
   <p>
       <m-named-pair 
            text="Realm Id"
            :value="token.realm_id"
        />

        <m-named-pair 
            text="last_refresh_time"
            :value="pretty_last_refresh_time"
        />

        <m-named-pair 
            text="access_token"
            :value="token.access_token"
        />

         <m-named-pair 
            text="refresh_token"
            :value="token.refresh_token"
        />

   </p>
   </div>

</v-container>
</m-pageframe>
</template>

<script>
const Time = require('@/js/time.js');

export default {
    data() {
        return {
            realm_choices: [
                {'text' : 'Sandbox', 'value': '4620816365202791290' },
                {'text' : 'Production', 'value': '9130348864147576'}
            ],

            realm_id: null,
            token: null,
        }
    },

    methods: {
        update() {
            if ( this.realm_id == null )
            {
                this.token = null;
                return;
            }

            this.$rc.showSpinner();
            
            this.$rc.getIntuitToken(
                this.realm_id,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.token = data;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.token = null;
                },
            );
        },

        onSetRefreshToken(new_token)
        {
            let post_data = {
                'realm_id' : this.realm_id,
                'refresh_token' : new_token
            };

            this.$rc.showSpinner();
            
            this.$rc.putIntuitToken(
                post_data,
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.update();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to update refresh token.');
                },
            );
        },
    },

    computed: {
        refresh_token() {

            if ( this.token == null ) 
                return null;

            return this.token.refresh_token;
        },

        pretty_last_refresh_time()  {
            if ( this.token == null ) return '';

            return Time.getTimeAndDate(this.token.last_refresh_time);
        }
    },
}
</script>

<style lang="scss" scoped>
</style>